/**
 * Sleep Karma Custom JavaScript
 * Includes dropdown menu functionality for the header navigation
 */

// Add dropdown menu functionality
document.addEventListener('DOMContentLoaded', function() {
  // Function to create and apply dropdown menu
  function createSleepProductsDropdown() {
    // First try to find the menu item using the class structure from the screenshot
    const sleepProductsItem = document.querySelector('li.wt-header__nav-teaser__item a[href*="sleep-products"]')?.closest('li');
    
    if (sleepProductsItem) {
      console.log('Sleep Products menu item found:', sleepProductsItem);
      
      // Check if the submenu already exists
      if (!sleepProductsItem.querySelector('.sleep-products-dropdown')) {
        // Create a dropdown menu
        const dropdown = document.createElement('ul');
        dropdown.className = 'sleep-products-dropdown';
        
        // Add menu items - these should match your Shopify menu structure
        const menuItems = [
          { text: 'Animal Protein', url: '/products/mouth-tape?variant=46066516656369' },
                   { text: 'Vegan Protein', url: '/products/mouth-tape?variant=46066516721905' },
          { text: 'Clean Creatine', url: '/products/nose-tape' },
                              { text: 'Accessories', url: '/collections/accessories' },
                    { text: 'See More', url: '/collections/sleep-products' }


        ];
        
        menuItems.forEach(item => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = item.url;
          a.textContent = item.text;
          li.appendChild(a);
          dropdown.appendChild(li);
        });
        
        // Add the dropdown to the menu item
        sleepProductsItem.appendChild(dropdown);
        
        // Position the dropdown properly
        sleepProductsItem.style.position = 'relative';
      }
    } else {
      console.log('Sleep Products menu item not found, trying alternative selectors');
      
      // Try alternative selector
      const altSleepProductsItem = document.querySelector('a[href*="sleep-products"]')?.closest('li');
      if (altSleepProductsItem) {
        console.log('Alternative Sleep Products menu item found:', altSleepProductsItem);
        
        // Similar approach as above
        if (!altSleepProductsItem.querySelector('.sleep-products-dropdown')) {
          const dropdown = document.createElement('ul');
          dropdown.className = 'sleep-products-dropdown';
          
          const menuItems = [
            { text: 'Mouth Tape', url: '/products/mouth-tape' },
            { text: 'Nose Tape', url: '/products/nose-tape' }
          ];
          
          menuItems.forEach(item => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = item.url;
            a.textContent = item.text;
            li.appendChild(a);
            dropdown.appendChild(li);
          });
          
          altSleepProductsItem.appendChild(dropdown);
          altSleepProductsItem.style.position = 'relative';
        }
      }
    }
  }
  
  // Initialize when DOM is loaded
  createSleepProductsDropdown();
  
  // Re-initialize on window resize and periodically check (in case of late loading)
  window.addEventListener('resize', createSleepProductsDropdown);
  
  // Check again after a delay, in case the menu loads dynamically
  setTimeout(createSleepProductsDropdown, 1000);
  
  // Add additional custom code here if needed in the future
});


// move title to top


/*
 document.addEventListener('DOMContentLoaded', () => {
 console.log('JavaScript is running');

  // Select the necessary elements
  const wrapper = document.querySelector('.wt-product__wrapper');
  const productMain = document.querySelector('.wt-product__main');
  const gallery = document.querySelector('[id^="MediaGallery-"]'); // This will match any ID that starts with MediaGallery-
  const productInfo = productMain ? productMain.querySelector('.wt-product__info') : null;
  const wtProduct = wrapper ? wrapper.querySelector('.wt-product') : null;

  console.log('Wrapper:', wrapper);
  console.log('Product Main:', productMain);
  console.log('Gallery:', gallery);
  console.log('Product Info:', productInfo);
  console.log('Wt Product:', wtProduct);

  if (wrapper && productMain && gallery && productInfo && wtProduct) {
    // Get all blocks inside wt-product__info
    const blocks = Array.from(productInfo.children);
    console.log('All Blocks:', blocks);

    // Find the title block
    const titleBlock = blocks.find(block => block.querySelector('.wt-product__name'));
    console.log('Title Block:', titleBlock);

    // Find the text block by class
    const textBlock = blocks.find(block => block.classList.contains('wt-product__text-block'));
    console.log('Text Block:', textBlock);
    
    // Find the star rating block
    const starRatingBlock = blocks.find(block => 
      block.id && block.id.includes('okendo_star_rating') || // Find by okendo star rating ID
      (block.classList && (
        block.classList.contains('shopify-app-block') || // Check for shopify app block class
        block.querySelector('[id*="okendo_star_rating"]') || // Find elements with okendo ID
        block.querySelector('[data-oke-reviews-version]') // Find by okendo attributes
      ))
    );
    console.log('Star Rating Block:', starRatingBlock);
    
    // Find the promo blocks (BEST SELLER and AWARD WINNING)
    // Target the parent elements with data-block-id that contain .wt-product__promo
    const promoBlocks = blocks.filter(block => 
      block.hasAttribute('data-block-id') && 
      block.getAttribute('data-block-id').startsWith('promo_')
    );
    console.log('Promo Blocks:', promoBlocks);

    if (titleBlock && textBlock) {
      // Create a wrapper div
      const titleWrapper = document.createElement('div');
      titleWrapper.classList.add('product-title-wrapper');

      // Create a container for promo blocks
      const promoContainer = document.createElement('div');
      promoContainer.classList.add('promo-container');
      
      // Add the promo blocks to the container
      if (promoBlocks && promoBlocks.length > 0) {
        promoBlocks.forEach(promoBlock => {
          promoContainer.appendChild(promoBlock);
        });
      }
      
      // Add the promo container to the title wrapper
      titleWrapper.appendChild(promoContainer);
      
      // Add the title block
      titleWrapper.appendChild(titleBlock);
      
      // Add the star rating block between title and text if it exists
      if (starRatingBlock) {
        titleWrapper.appendChild(starRatingBlock);
      }
      
      // Add the text block
      titleWrapper.appendChild(textBlock);

      // Insert the wrapper into the wt-product div, before the gallery
      wtProduct.insertBefore(titleWrapper, gallery);
      console.log('Title wrapper moved successfully');

      // Log the updated DOM structure
      console.log('Updated wt-product children:', Array.from(wtProduct.children));

      // On desktop, move the title wrapper back into wt-product__main
      if (window.innerWidth > 900) {
        productMain.insertBefore(titleWrapper, productInfo);
      }

      // Add a resize listener to handle window resizing
      window.addEventListener('resize', () => {
        if (window.innerWidth > 900) {
          productMain.insertBefore(titleWrapper, productInfo);
        } else {
          wtProduct.insertBefore(titleWrapper, gallery);
        }
      });
    } else {
      console.log('Title or Text block not found');
    }
  } else {
    console.log('One or more required elements not found');
  }
});

*/


document.addEventListener('DOMContentLoaded', function() {
  const duplicateButton = document.querySelector('.js-start-now-duplicate');
  const scrollTriggerPoint = 1000;
  
  if (duplicateButton) {
    // Add click functionality
    duplicateButton.addEventListener('click', function() {
      const originalButton = document.querySelector('#ProductSubmitButton-template--18998313222385__main');
      if (originalButton) {
        originalButton.click();
      } else {
        const submitButton = document.querySelector('button[name="add"]');
        if (submitButton) {
          submitButton.click();
        }
      }
    });
    
    // Function to check if cart drawer is open
    function isCartDrawerOpen() {
      const cartDrawer = document.querySelector('#CartDrawer');
      return cartDrawer && cartDrawer.classList.contains('is-open');
    }
    
    // Function to toggle button visibility based on scroll position AND cart drawer state
    function toggleButtonVisibility() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const shouldShowBasedOnScroll = scrollPosition > scrollTriggerPoint;
      const cartDrawerOpen = isCartDrawerOpen();
      
      // Show button only if scrolled enough AND cart drawer is closed
      if (shouldShowBasedOnScroll && !cartDrawerOpen) {
        duplicateButton.classList.add('show');
      } else {
        duplicateButton.classList.remove('show');
      }
    }
    
    // Scroll detection with throttling
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(toggleButtonVisibility, 10);
    });
    
    // Watch for cart drawer changes using MutationObserver
    const cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            toggleButtonVisibility();
          }
        });
      });
      
      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    // Also listen for body class changes (some themes toggle cart state on body)
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          toggleButtonVisibility();
        }
      });
    });
    
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Initial check
    toggleButtonVisibility();
  }
});
